import { getFuelStatementData } from '_services/accountsServices/fuelStationServices';
import BootstrapTable from 'components/BootstrapTable'
import useDocumentTitle from 'hooks/useDocumentTitle';
import { AddEditMarkCompleteRemainder, AddEditServiceReminder, AddEditVehicleDocumentsModal, AddOtherDocumentsModal } from 'modals';
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import StorageService from 'utils/StorageServices';
import { TiEdit } from "react-icons/ti";
import { FaRegTrashAlt } from 'react-icons/fa';
import moment from 'moment';
import toast from 'react-hot-toast';
import { deleteVehicleDocumentData, getVehicleDocumentsListData } from '_services/accountsServices/vehicleDocTypeServices';
import { UserContext } from 'context';
import { utils } from 'helper';
import { ButtonHeading, CityDropdownForTrip, CommonDateRange, CommonInput, CommonModal, CustomPagination, CustomSelect } from 'components'
import { AiOutlineEye } from 'react-icons/ai';
import '../../Accounts'
import './servicereminder.css';
import { StatusDropdown } from 'pages/Fastags';
import SingleSelectDropdownInfinite from 'components/common/SingleSelectDropdownInfinite/SingleSelectDropdownInfinite';
import { deleteServiceRemainder, getItemsList, getServiceList, getServiceRemainder, getServiceRemainderCounts } from '_services/workShopServices/workShopServices';
import { getAllVehicleNumber, venderDropdownApi } from '_services';
import { StorageServices } from 'utils';
import { BsThreeDots } from 'react-icons/bs';
import { constant } from 'constants/constant';

const docCountArray = [
    { key: 'Active', label: "Active Reminders", counts: 0 },
    { key: 'Overdue', label: "Overdue Services", counts: 0 },
    { key: 'Due soon', label: "Due Soon", counts: 0 },
    { key: 'Completed', label: "Completed", counts: 0 },
    { key: '', label: "Fleets with Reminders", counts: 0 },
]

const ServiceReminder = ({ vehicleNo }) => {
    useDocumentTitle("Service Reminder | T360");

    const [serviceRemainderModal, setServiceRemainderModal] = useState(false);
    const [markRemainderModal, setMarkRemainderModal] = useState({
        isOpen: "",
        tag: ""
    });

    const itemsPerPage = 25;
    const [serviceRemainderData, setServiceRemainderData] = useState([]);
    const [serviceRemainderCounts, setServiceRemainderCounts] = useState(docCountArray);

    const [loading, setLoading] = useState(false);

    const [totalItems, setTotalItems] = useState(0);
    const [filter, setFilter] = useState({
        company_id: StorageService.getCompanyId(),
        limit: 25,
        offset: 1,
        search: '',
        start_date: '',
        end_date: '',
        vehicle_number: {},
        service_type: {},
        service_status: 'Active'
    });

    const [selectedRange, setSelectedRange] = useState({
        startDate: '', // moment().startOf("month")
        endDate: '', // moment().endOf("month")
    });

    const [isDelete, setIsDelete] = useState(false);

    const deleteHandler = (item) => {
        setIsDelete(item)
    }

    const submitDeleteRemainder = async () => {
        setLoading(true);
        try {
            let object = {
                id: isDelete?._id,
                status: 2,
            }
            const res = await deleteServiceRemainder(object);
            if (res?.responseCode == 200) {
                if (res?.responseMessage) {
                    toast.success(`${res?.responseMessage}`);
                }
                getServiceReminderList();
                getServiceReminderListCounts();
                setLoading(false);
                setIsDelete(false);
            } else {
                if (res?.responseMessage) {
                    toast.error(res?.responseMessage);
                }
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    let propsObject = {
        isOpen: isDelete,
        closeModal: setIsDelete,
        modalTitle: "Confirmation",
        submitTitle: "Confirm",
        cancleTitle: "Close",
        onSubmit: submitDeleteRemainder,
        isLoadding: loading,
    }

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
    };

    const toggleOffcanvas = () => {
        setServiceRemainderModal(true);
    };

    const columns = [
        { header: "Vehicle", accessor: "vehicle" },
        { header: "Service Type", accessor: "service_type" },
        { header: "Last Service", accessor: "last_service" },
        { header: "Due Date", accessor: "due_date" },
        { header: "Due at KM", accessor: "due_at_km" },
        { header: "Vehicle KM", accessor: "vehicle_km" },
        { header: "Alert Type", accessor: "alert_type" },
        { header: "Association", accessor: "association" },
        { header: "Status", accessor: "status" },
        { header: "", accessor: "action" },
    ];

    const isDateGreaterThenEqual = (firstDate, secondDate) => {
        if (!firstDate || !secondDate) return false;

        const d1 = new Date(firstDate);
        const d2 = new Date(secondDate);

        if (isNaN(d1.getTime()) || isNaN(d2.getTime())) {
            console.error("Invalid date format");
            return false;
        }

        return d1.getTime() >= d2.getTime();
    };

    const isDateLessThenEqual = (firstDate, secondDate) => {
        if (!firstDate || !secondDate) return false;

        const d1 = new Date(firstDate);
        const d2 = new Date(secondDate);

        if (isNaN(d1.getTime()) || isNaN(d2.getTime())) {
            console.error("Invalid date format");
            return false;
        }

        return d1.getTime() <= d2.getTime();
    };

    const getDaysDiff = (date1, date2) => {
        const d1 = new Date(date1);
        const d2 = new Date(date2);

        const diffMs = Math.abs(d2 - d1);
        return Math.floor(diffMs / (1000 * 60 * 60 * 24));
    };


    const rowListData = (data) => {
        return data?.map((item, i) => {
            return {
                ...item,
                vehicle: (
                    <div className='_locationWid_bx'>
                        <p className="_tblText"> {item?.vehicle?.vehicle_no ? item?.vehicle?.vehicle_no : '-'} </p>
                        <p className="_lgtText"> {item?.vehicle?.lorry_type_id?.lorry_type} - {item?.vehicle?.vehicle_type_id?.name} </p>
                    </div>
                ),
                service_type: (
                    <div className='_locationWid_bx'>
                        <p className="_tblText"> {item?.item?.name} </p>
                        <p className="_lgtText"> Every {item?.next_reminder_days ? item?.next_reminder_days : 0} Days or {item?.next_meter_interval ? item?.next_meter_interval : 0} KM </p>
                    </div>
                ),
                last_service: (
                    <div className='_locationWid_bx'>
                        <p className="_tblText"> {moment(item?.service_date).format('DD MMM YYYY')} </p>
                        <p className="_lgtText"> {utils.getTimeDifferenceFromToday(item?.service_date)} </p>
                    </div>
                ),
                due_date: (<React.Fragment> {moment(item?.due_date).format('DD MMM YYYY')} </React.Fragment>),
                due_at_km: (<React.Fragment> {item?.due_kms ? item?.due_kms : 0} KM </React.Fragment>),
                vehicle_km: (<React.Fragment> {item?.vehicle_id?.last_kms ? item?.vehicle_id?.last_kms : 0} KM  </React.Fragment>),
                alert_type: <span style={{ color: (filter?.service_status === 'Active' ? '#48CA32' : (filter?.service_status === 'Overdue' ? "#FF5561" : (filter?.service_status === "Due soon" ? "#FFB336" : "#059669"))) }}> {filter?.service_status === 'Active' ? 'Healthy' : (filter?.service_status === 'Overdue' ? "Overdue" : (filter?.service_status === "Due soon" ? "Due soon" : "Completed"))}
                    {/* {
                        ((((item?.due_kms >= item?.vehicle_id?.last_kms) && ((item?.due_kms - item?.vehicle_id?.last_kms) <= 50))) || (isDateGreaterThenEqual(item?.due_date, new Date()) && (getDaysDiff(item?.due_date, new Date())) <= 10)) ?
                            <span style={{ color: '#FFB336' }}> Due soon </span> :
                            (((item?.due_kms < item?.vehicle_id?.last_kms) || (isDateLessThenEqual(item?.due_date, new Date())) ?
                                <span style={{ color: '#FF5561' }}> Overdue </span> : (
                                    (item?.due_kms > item?.vehicle_id?.last_kms) || (isDateGreaterThenEqual(item?.due_date, new Date())) ?
                                        <span style={{ color: '#48CA32' }}> Healthy </span> : '-')
                            ))
                    } */}
                </span>,
                association: (<React.Fragment>
                    <div className='_locationWid_bx'>
                        {item?.association_type === 1 ? 'Service Bill' : 'Reminder'}
                        {item?.association_type === 1 && <p className="_lgtText"> {item?.item?.code ? item?.item?.code : ''} </p>}
                    </div>
                </React.Fragment>),
                status: (
                    <div className='_locationWid_bx'>
                        <p className="_tblText" style={{ fontWeight: 500, color: (item?.service_status === 'Active' ? '#1900ffff' : (item?.service_status === 'Completed' ? '#059669' : (item?.service_status === 'Due' ? '#FFB336' : '#FF5561'))) }}> {item?.service_status} </p>
                        {item?.service_status === 'Completed' && <p className="_lgtText"> {utils.getDate(item?.completion_date, '/', 'dmy')} </p>}
                    </div>
                ),
                action: (
                    <React.Fragment>
                        <div className="signDropdown">
                            <button className="dropbtn11">
                                <BsThreeDots />
                            </button>
                            <div className="dropdownContent _extrContes">
                                {item?.service_status !== 'Completed' && <div className="_avPointer" onClick={() => setMarkRemainderModal({ isOpen: item, tag: 'Completed' })}>
                                    <span className="_samAnchor">
                                        Mark Completed
                                    </span>
                                </div>}
                                <div className="_avPointer" onClick={() => setServiceRemainderModal(item)}>
                                    <span className="_samAnchor">
                                        Add Reminder
                                    </span>
                                </div>
                                <Link
                                    to='/WorkshopServicing/AddService'
                                    className="_avPointer"
                                    style={{ textDecoration: "none" }}
                                    state={{ vehicleData: item?.vehicle || item?.vehicle_id }}
                                >
                                    <span className="_samAnchor">
                                        Add Reminder + Expense
                                    </span>
                                </Link>
                                <div className="_avPointer" onClick={() => deleteHandler(item)}>
                                    <span className="_samAnchor">
                                        Delete
                                    </span>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                ),
            };
        });
    };

    const handleApply = (newRange) => {
        setSelectedRange(newRange);
        setFilter((prev) => ({
            ...prev,
            start_date: moment(newRange.startDate).format("YYYY-MM-DD"),
            end_date: moment(newRange.endDate).format("YYYY-MM-DD"),
            offset: 1,
        }));
    };

    const fetchVehicle = async (search, page, limit) => {
        const res = await getAllVehicleNumber({
            company_id: StorageServices?.getCompanyId(),
            offset: page,
            limit,
            search,
            vehicle_ownership: [1, 3]
        });
        if (res?.responseCode === 200) {
            const list = res?.data?.vehicle_list?.map((i) => ({
                ...i,
                name: `${i?.vehicle_no}`,
                ownershipStatus: i?.vehicle_ownership,
            }));
            return {
                items: list,
                total: res?.data?.total_record,
            };
        } else {
            return { items: [], total: 0 };
        }
    };

    const getServiceReminderList = async () => {
        setLoading(true);
        const payload = {
            limit: filter.limit,
            offset: filter.offset,
            company_id: filter.company_id,
            filters: {
                search: filter.search,
                start_date: filter.start_date,
                end_date: filter.end_date,
                vehicle_number: filter.vehicle_number?.name,
                service_type: filter.service_type?._id,
                service_status: filter.service_status
            }
        }
        try {
            const res = await getServiceRemainder(payload)
            if (res?.responseCode === 200) {
                setServiceRemainderData(res?.data?.list)
                setTotalItems(res?.data?.total_record)
                setLoading(false);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }

    const getServiceReminderListCounts = async () => {
        setLoading(true);
        const payload = {
            company_id: filter.company_id,
        }
        try {
            const res = await getServiceRemainderCounts(payload)
            if (res?.responseCode === 200) {

                let updateArray = [
                    { key: 'Active', label: "Active Reminders", counts: res?.data?.active_reminder },
                    { key: 'Overdue', label: "Overdue Services", counts: res?.data?.overdue },
                    { key: 'Due soon', label: "Due Soon", counts: res?.data?.due_soon },
                    { key: 'Completed', label: "Completed", counts: res?.data?.completed },
                    { key: '', label: "Fleets with Reminders", counts: `${res?.data?.service_fleet > 0 ? res?.data?.service_fleet : 0} / ${(res?.data?.total_fleet > 0 ? res?.data?.total_fleet : 0)}` },
                ]

                setServiceRemainderCounts(updateArray)
                setLoading(false);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getServiceReminderList();
    }, [filter])

    useEffect(() => {
        getServiceReminderListCounts();
    }, [])

    const resetClear = () => {
        setSelectedRange({
            startDate: '',
            endDate: '',
        })
        setFilter((s) => ({
            ...s,
            offset: 1,
            search: '',
            start_date: '',
            end_date: '',
            vehicle_number: {},
            service_type: {},
        }))
    }

    let serviceRemainderModelProps = {
        isOpen: serviceRemainderModal,
        closeModal: (e) => setServiceRemainderModal(false),
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: serviceRemainderModal?.isDetails ? "View Service Reminder" : (serviceRemainderModal?._id ? 'Add Service Reminder' : 'Add Service Reminder'),
        submitTitle: serviceRemainderModal?.isDetails ? "View Service Reminder" : (serviceRemainderModal?._id ? 'Add Service Reminder' : 'Add Service Reminder'),
        headerPart: false,
        footerPart: true,
        callListApi: () => { getServiceReminderList(); getServiceReminderListCounts() },
    }

    let markRemainderModelProps = {
        isOpen: markRemainderModal?.isOpen,
        closeModal: (e) => setMarkRemainderModal(false),
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: markRemainderModal?.isDetails ? "View Mark Complete" : (markRemainderModal?._id ? 'Update Mark Complete' : 'Mark Complete'),
        submitTitle: markRemainderModal?.isDetails ? "View Mark Complete" : (markRemainderModal?._id ? 'Update Mark Complete' : 'Mark Complete'),
        headerPart: false,
        footerPart: true,
        callListApi: () => { getServiceReminderList(); getServiceReminderListCounts() },
    }

    const fetchItemsList = useCallback(async (search, page, limit) => {
        try {
            const response = await getItemsList({
                company_id: StorageService.getCompanyId(),
                offset: page,
                limit,
                search,
            });

            if (response?.responseCode === 200) {
                const vendors = response.data.itemData
                    ?.filter(vendor => vendor?.part_category_id?._id)
                    .map(vendor => ({
                        label: vendor.part_category_id.name,
                        value: vendor.part_category_id._id,
                        ...vendor.part_category_id
                    }));

                return {
                    items: vendors,
                    total: response.data.total_record || vendors.length,
                };
            }

            toast.error(response?.responseMessage);
            return { items: [], total: 0 };
        } catch (error) {
            return { items: [], total: 0 };
        }
    }, []);

    return (
        <>
            <ButtonHeading
                title={"Service Reminder"}
                onClick={toggleOffcanvas}
                buttonTitle="Add Service Reminder"
                showSearchFilter={{ search: false, filterOption: false, filterCount: true }}
            />

            <div className='__vhlMain_fx __servReminder'>
                <div className='__serviceTab_rs _etra_bgx _avPointer'>
                    {serviceRemainderCounts.map(item => (
                        <div
                            key={item.key}
                            className={`__serviceTab_flt ${(item.key !== "" && filter?.service_status == item.key) ? "__trvlActive" : ""}`}
                            onClick={(e) => item?.key != "" && setFilter((s) => ({ ...s, service_status: item?.key, offset: 1 }))}>
                            <h4> {item?.counts} </h4>
                            <p className=''> {item?.label} </p>
                        </div>
                    ))}
                </div>

                <div className='pd_manufactoer'>
                    <div className='__filtsTb_flexMain'>
                        <div className='__filtsTb_flex'>
                            <div>
                                <CommonDateRange
                                    initialStartDate={selectedRange.startDate || ""}
                                    initialEndDate={selectedRange.endDate || ""}
                                    onApply={handleApply}
                                    datePrefield={!!(selectedRange.startDate && selectedRange.endDate)}
                                />
                            </div>

                            <div style={{ flex: '0 0 220px' }}>
                                <SingleSelectDropdownInfinite
                                    label="Vehicle Number"
                                    placeholder="Vehicle Number"
                                    fetchData={fetchVehicle}
                                    selectedItem={filter?.vehicle_number}
                                    onChange={(data) => setFilter((pre) => ({ ...pre, vehicle_number: data }))}
                                    loadOnOpen={true}
                                    vehicleStatus={false}
                                />
                            </div>

                            <div style={{ flex: '0 0 220px' }}>
                                <div className='singleDiv'>
                                    <CityDropdownForTrip
                                        label="Service Type"
                                        placeholder="Service Type"
                                        fetchData={fetchItemsList}
                                        pageSize={20}
                                        selectedItem={filter?.service_type ? filter?.service_type : null}
                                        onChange={(data) => setFilter((pre) => ({ ...pre, service_type: data }))}
                                    // error={formError['service_type.label']}
                                    // errorMessage={formError['service_type.label']}
                                    />
                                </div>
                            </div>
                            <div className='__fInx_bx'>
                                <CommonInput
                                    type="search"
                                    label='Search'
                                    placeholder='Search'
                                    name='search'
                                    value={filter.search}
                                    maxLength="30"
                                    onInput={utils.maxLengthCheck}
                                    onChange={(e) => setFilter((s) => ({ ...s, search: e.target.value }))}
                                />
                            </div>
                            {(filter.search || filter?.vehicle_number?.name || filter.service_type?.value || filter?.start_date || filter?.end_date) ? <div>
                                <button
                                    className='manuRsret'
                                    onClick={(e) => resetClear(e)}
                                >
                                    Clear
                                </button>
                            </div> : <></>}
                        </div>
                    </div>
                </div>
                <div className="_tabWith_outTab">
                    <BootstrapTable
                        tableClass="companyTable_bx __txBtab"
                        columns={columns}
                        data={rowListData(serviceRemainderData?.length > 0 ? serviceRemainderData : [])} // 
                        isLoading={loading}
                    />
                    {/* {serviceRemainderData?.length > 0 && ( */}
                    <div className="paginationFt_avt " style={{ borderBottom: 'none' }}>
                        <CustomPagination
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            currentPage={filter.offset}
                            onPageChange={handlePageChange}
                        />
                    </div>
                    {/* )} */}
                </div>
            </div>

            {
                serviceRemainderModal && (
                    <AddEditServiceReminder {...serviceRemainderModelProps} />
                )
            }

            {
                markRemainderModal?.tag === 'Completed' && (
                    <AddEditMarkCompleteRemainder {...markRemainderModelProps} />
                )
            }

            {
                isDelete?.company_id && (
                    <CommonModal {...propsObject}>
                        <p className='p-3'> Are you sure you want to delete {isDelete?.name} ?</p>
                    </CommonModal>
                )
            }
        </>
    )
}

export default ServiceReminder;